// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Op} from './op.js'

export class AppendOpsEvent {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): AppendOpsEvent {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsAppendOpsEvent(bb: flatbuffers.ByteBuffer, obj?: AppendOpsEvent): AppendOpsEvent {
    return (obj || new AppendOpsEvent()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsAppendOpsEvent(bb: flatbuffers.ByteBuffer, obj?: AppendOpsEvent): AppendOpsEvent {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new AppendOpsEvent()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  ops(index: number, obj?: Op): Op | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset
      ? (obj || new Op()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!)
      : null
  }

  opsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startAppendOpsEvent(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addOps(builder: flatbuffers.Builder, opsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, opsOffset, 0)
  }

  static createOpsVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startOpsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static endAppendOpsEvent(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // ops
    return offset
  }

  static createAppendOpsEvent(builder: flatbuffers.Builder, opsOffset: flatbuffers.Offset): flatbuffers.Offset {
    AppendOpsEvent.startAppendOpsEvent(builder)
    AppendOpsEvent.addOps(builder, opsOffset)
    return AppendOpsEvent.endAppendOpsEvent(builder)
  }
}
